export const DEFAULT_MODULOR_DOMAIN = 'mdlr.tech';
